<quill-editor 
  [id]="id" 
  [(ngModel)]="value" 
  [format]="format" 
  class="lo_sensitive {{additionalClasses}}"
  [placeholder]="placeholder"
  [modules]="quillConfig.modules"
  (onContentChanged)="onContentChanged($event)"
  [disabled]="disabled" />
  